import React from "react";
import { useTranslation } from "react-i18next";

export const LanguageItem = ({ flag, language, label }) => {
    const { i18n } = useTranslation();

    return (
        <div className="flex items-center gap-2">
            <img
                src={flag}
                alt="egypt"
                className="w-[14px] small:w-[14.5px] mobile:w-[15px] tablet:w-[15.5px] desktop:w-[16px] tv:w-[16.5px] h-[14px] small:h-[14.5px] mobile:h-[15px] tablet:h-[15.5px] desktop:h-[16px] tv:h-[16.5px]"
            />
            <div
                className={
                    i18n.language === language ? "font-semibold" : "font-normal"
                }
            >
                {label}
            </div>
        </div>
    );
};
